module.exports = __webpack_public_path__ + "img/countries.a31722fd.svg";